export default{
    // apiUrl:'http://192.168.1.199:94',
    // apiUrl:'https://jobs.puhuijishu.top',//线上域名
    apiUrl : `${location.origin}` // 自动获取
}
